module.exports = __webpack_public_path__ + "static/media/marker-icon-orange.33debfea.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/images/marker-icon-orange.png
 ** module id = 862
 ** module chunks = 0
 **/